module.exports = __webpack_public_path__ + "img/MAC1100_1-1.90e719d2.jpg";